<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('changeAccount.irktProfili')" />
      <div
        v-if="showDashboard===0"
        class="row"
      >
        <div
          v-if="companyDetails"
          class="col-xl-12 "
        >
          <div class="row">
            <div class="col-xl-7">
              <div
                class="card"
                style="border: 2px dashed #007bff; "
              >
                <div
                  class="card-body "
                >
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        id="fileInput"
                        ref="file"
                        type="file"
                        style="display: none"
                        @change="setPhoto"
                      >

                      <img
                        :src="getPhoto(companyDetails.logo,'mediumCropped')"
                        alt=""
                        class="img-thumbnail rounded-circle w-100"
                      >
                      <p
                        v-if="!companyDetails.logo"
                        class="fs-26 text-danger"
                      >
                        *
                      </p>

                      <div
                        class="mt-2 text-center"
                      >
                        <button
                          class="btn btn-sm mr-2 btn-outline-primary px-2"
                          @click="selectPhoto"
                        >
                          <feather
                            type="upload"
                            size="16"
                          />
                        </button>
                        <button
                          v-if="user.photo"
                          class="btn btn-sm mr-2 btn-outline-danger px-2"
                          @click.prevent="removeProfilePhoto"
                        >
                          <feather
                            type="trash"
                            size="16"
                          />
                        </button>

                        <div
                          v-if="uploadProgress >0 && uploadProgress <100"
                          class="progress"
                        >
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            aria-valuenow="75"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            :style="{width: `${uploadProgress}%`}"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div>
                        <div class="lead font-weight-bold">
                          {{ companyDetails.name }}
                          {{ getCompanyFormat(companyDetails.format) }}
                        </div>
                        <div
                          v-if="companyDetails.legalForm === 'JURIDICAL_PERSON'"
                          class="text-secondary"
                        >
                          {{ $t('companyProfile.hquqiXs') }}
                        </div>
                        <div
                          v-if="companyDetails.legalForm === 'INDIVIDUAL'"
                          class="text-secondary"
                        >
                          {{ $t('companyProfile.fizikiXs') }}
                        </div>
                      </div>
                      <hr>
                      <div v-if="companyDetails.legalForm!=='PERSONAL'">
                        <div class="text-secondary">
                          {{ $t('companyProfile.ven') }}
                        </div>
                        <div class="lead">
                          {{ companyDetails.taxId }}
                        </div>
                      </div>
                      <div v-else>
                        <div class="lead">
                          {{ $t('companyProfile.frdiXsProfili') }}
                        </div>
                      </div>
                      <hr>

                      <div
                        v-if="companyDetails.legalForm!=='PERSONAL'"
                        class="d-flex justify-content-between"
                      >
                        <div>
                          <div class="text-secondary">
                            {{ $t('companyProfile.nvan') }}
                          </div>
                          <div class="lead">
                            <span v-if="companyDetails.address">{{ companyDetails.address }}</span>
                            <a
                              v-else-if="!companyDetails.address"
                              href="#"
                              @click.prevent="changeCompanyAddress()"
                            >
                              {{ $t('companyProfile.nvanLavEt') }} <p
                                v-if="companyDetails.legalForm !== 'PERSONAL'"
                                class="fs-26 text-danger"
                              >*</p>
                            </a>
                          </div>
                        </div>
                        <div v-if="companyDetails.address ">
                          <a
                            href="#"
                            @click.prevent="changeCompanyAddress()"
                          >
                            <feather type="edit-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div>
                    <div
                      v-if="companyDetails.countryCode!=='AZ'&& companyDetails.legalForm!=='PERSONAL'"
                      class="form-group"
                    >
                      <label>{{ $t('companyProfile.taxDocument') }}</label>
                      <br>
                      <button
                        v-if="!companyDetails.taxIdDocument"
                        class="btn btn-primary"
                        @click="triggerFileInput('taxFile')"
                      >
                        {{ $t('companyProfile.taxDocumentLavEt') }}
                      </button>
                      <input
                        ref="taxFile"
                        type="file"
                        class="d-none"
                        @change="uploadTaxDocument()"
                      >
                      <div
                        v-if="companyDetails.taxIdDocument"
                        class="card position-relative"
                        style="margin-bottom: 0"
                      >
                        <a
                          target="_blank"
                          :href="mediaBase + companyDetails.taxIdDocument"
                          class="card h-100 border border-dark text-center"
                        >
                          <div class="card-body d-flex justify-content-center align-items-center">
                            {{ companyDetails.taxIdDocument.split('/').pop() }}
                          </div>
                        </a>
                        <div
                          class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                          style="cursor: pointer;"
                        >
                          <feather
                            type="trash"
                            @click="deleteTaxDocument"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Official Company Email -->
                    <div class="form-group">
                      <label>{{
                        company.legalForm !== 'PERSONAL' ? $t('companyProfile.officialEmail') : $t('companyProfile.officialEmailPersonal')
                      }}</label>
                      <div class="d-flex align-items-center">
                        <input
                          v-model="companyDetails.confirmEmail"
                          type="email"
                          class="form-control"
                          :disabled="!emailEditMode"
                        >
                        <button
                          v-if="emailEditMode"
                          class="btn btn-danger ml-2 blink"
                          @click="saveCompanyEmail"
                        >
                          <i class="fa fa-save" />
                        </button>
                        <button
                          v-else
                          class="btn btn-outline-primary ml-2"
                          @click="enableEmailEditMode"
                        >
                          <i class="fa fa-edit" />
                        </button>
                      </div>
                    </div>

                    <!-- Primary Contact's Mobile Number -->
                    <div class="form-group">
                      <label>{{
                        company.legalForm !== 'PERSONAL' ? $t('companyProfile.primaryContactMobile') : $t('companyProfile.primaryContactMobilePersonal')
                      }}</label>
                      <div class="d-flex align-items-center">
                        <VuePhoneNumberInput
                          v-model="companyDetails.contactPhone"
                          :default-country-code="'AZ'"
                          :disabled="!phoneEditMode"
                        />
                        <button
                          v-if="phoneEditMode"
                          class="btn btn-danger ml-2 blink"
                          @click="saveCompanyPhone"
                        >
                          <i class="fa fa-save" />
                        </button>
                        <button
                          v-else
                          class="btn btn-outline-primary ml-2"
                          @click="enablePhoneEditMode"
                        >
                          <i class="fa fa-edit" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 m-1">
                      <button
                        class="btn"
                        :class="buttonClass"
                        :disabled="companyDetails.systemVerifiedCompany === 2 || companyDetails.systemVerifiedCompany === 1"
                        @click="submitVerificationRequest"
                      >
                        {{ buttonText }}
                      </button>
                      <div
                        v-if="companyDetails.systemVerifiedCompany === 0"
                        class="mt-1 text-secondary"
                      >
                        Profilinizi təsdiq etmək üçün məlumatları doldurub portal adminstratoruna göndərin
                      </div>
                      <div
                        v-if="companyDetails.systemVerifiedCompany === 3"
                        class="text-danger"
                      >
                        {{ companyDetails.rejectReason }}
                      </div>
                    </div>
                  </div>
                  <UserCompanyAdminDetails />
                </div>
              </div>


              <div
                v-if="companyDetails.legalForm!=='PERSONAL'"
                class="mt-5"
              >
                <h3>{{ $t('companyProfile.irktProfillri') }}</h3>

                <div class="card">
                  <div class="card-header">
                    <a
                      v-for="k in Object.keys(profiles)"
                      :key="k"
                      class="btn m-2"
                      :class="[activeProfile===k?'btn-primary':'btn-outline-primary']"
                      aria-current="true"
                      href="#"
                      @click.prevent="activeProfile = k"
                    >
                      {{ getProfileName(k) }}
                    </a>
                  </div>

                  <div v-if="activeProfile !==''">
                    <div class="card-body">
                      <h4>{{ $t('companyProfile.profili', {getProfileName: getProfileName(activeProfile)}) }}</h4>
                      <p>
                        {{ $t('companyProfile.irktinHrMvcudBirBiznesProfiliZrHmBiznesReytinqiVAk') }}
                      </p>

                      <div v-if="activeProfile ==='SUPPLIER'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companySupplyRating "
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companySupplyRating || '0.0' }}</span>
                      </div>
                      <div v-else-if="activeProfile ==='PROCUREMENT'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companyProcurementRating"
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companyProcurementRating || '0.0' }}</span>
                      </div>
                      <div v-else>
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i class="fa fa-3x fa-star-o text-secondary" />
                        </span>

                        <span class="h2 ml-3 text-warning">0.0</span>
                      </div>
                    </div>
                    <div class="card-body">
                      <CompanyRateStatistics
                        :company-id="company.id"
                        :profile-type="activeProfile"
                      />
                    </div>
                    <hr>
                    <div class="card-body">
                      <div v-if="editProfileIsOpen">
                        <form @submit.prevent="saveProfile">
                          <div class="row">
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.telefon') }}</label>

                              <VuePhoneNumberInput
                                v-model="editingProfile.phone"
                                :default-country-code="'AZ'"
                                :required="true"
                                :no-example="true"
                                @update="numberUpdated($event)"
                              />
                            </div>
                            <div class="col-6 mb-3">
                              <label>E-mail *</label>
                              <input
                                v-model="editingProfile.email"
                                type="email"
                                class="form-control"
                                required
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.websayt') }}</label>
                              <input
                                v-model="editingProfile.website"
                                type="text"
                                class="form-control"
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyProfile.linkedin2') }}</label>
                              <input
                                v-model="editingProfile.linkedin"
                                type="text"
                                class="form-control"
                              >
                            </div>
                          </div>

                          <div class="mb-3">
                            <button
                              type="submit"
                              class="btn btn-primary mr-2"
                            >
                              {{ $t('sectorSelectionModal.yaddaSaxla') }}
                            </button>
                            <a
                              class="btn btn-outline-primary  "
                              @click.prevent="editProfileIsOpen = false"
                            >
                              {{ $t('companyProfile.lvEt2') }}
                            </a>
                          </div>
                        </form>
                      </div>
                      <div v-else>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.telefon') }}</strong> <br>
                          <em>{{ companyActiveProfileData.phone || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.email') }}</strong> <br>
                          <em>{{ companyActiveProfileData.email || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.websayt') }}</strong> <br>
                          <em>{{ companyActiveProfileData.website || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.linkedin') }}</strong> <br>
                          <em>{{ companyActiveProfileData.linkedin || '-' }}</em>
                        </p>

                        <p v-if="!hasAdmin || isAdmin">
                          <button
                            class="btn btn-outline-primary"
                            @click.prevent="editProfileIsOpen= true"
                          >
                            {{ $t('companyProfile.mlumatlarDzliEt') }}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 mt-4">
                  <ul
                    id="myTab"
                    class="nav nav-tabs"
                    role="tablist"
                  >
                    <li
                      class="nav-item"
                      role="presentation"
                    >
                      <a
                        id="distributor-tab"
                        class="nav-link"
                        :class="{ active: activeTab === 'distributor' }"
                        role="tab"
                        aria-controls="distributor"
                        aria-selected="activeTab === 'distributor'"
                        @click="activeTab = 'distributor'"
                      >
                        Distribyutorluq sənədləri
                      </a>
                    </li>
                    <li
                      class="nav-item"
                      role="presentation"
                    >
                      <a
                        id="certificates-tab"
                        class="nav-link"
                        :class="{ active: activeTab === 'certificates' }"
                        role="tab"
                        aria-controls="certificates"
                        aria-selected="activeTab === 'certificates'"
                        @click="activeTab = 'certificates'"
                      >
                        Sertifikat və lisenziyalar
                      </a>
                    </li>
                    <li
                      class="nav-item"
                      role="presentation"
                    >
                      <a
                        id="contracts-tab"
                        class="nav-link"
                        :class="{ active: activeTab === 'contracts' }"
                        role="tab"
                        aria-controls="contracts"
                        aria-selected="activeTab === 'contracts'"
                        @click="activeTab = 'contracts'"
                      >
                        Oxşar işlərlə bağlı müqavilə və referanslar
                      </a>
                    </li>
                  </ul>
                  <div
                    id="myTabContent"
                    class="tab-content mt-3"
                  >
                    <div
                      id="distributor"
                      class="tab-pane fade"
                      :class="{ show: activeTab === 'distributor', active: activeTab === 'distributor' }"
                      role="tabpanel"
                      aria-labelledby="distributor-tab"
                    >
                      <!-- Distributor Documents Content -->
                      <div v-if="documents.distributor.length === 0">
                        <p>No documents available.</p>
                      </div>
                      <div
                        v-for="(doc) in documents.distributor"
                        :key="doc"
                        class="col-md-7 mb-3"
                      >
                        <div
                          class="card position-relative"
                          style="margin-bottom: 0"
                        >
                          <a
                            target="_blank"
                            :href="mediaBase + doc"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ doc.split('/').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteDocument('distributor', doc)"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        @click="triggerFileInput('distributorFile')"
                      >
                        Upload File
                      </button>
                      <input
                        ref="distributorFile"
                        type="file"
                        class="d-none"
                        @change="uploadDocument('distributor')"
                      >
                    </div>
                    <div
                      id="certificates"
                      class="tab-pane fade"
                      :class="{ show: activeTab === 'certificates', active: activeTab === 'certificates' }"
                      role="tabpanel"
                      aria-labelledby="certificates-tab"
                    >
                      <!-- Certificates and Licenses Content -->
                      <div v-if="documents.certificates.length === 0">
                        <p>No documents available.</p>
                      </div>
                      <div
                        v-for="(doc, index) in documents.certificates"
                        :key="index"
                        class="col-md-3 mb-3"
                      >
                        <div
                          class="card position-relative"
                          style="margin-bottom: 0"
                        >
                          <a
                            target="_blank"
                            :href="mediaBase + doc"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ doc.split('/').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteDocument('certificates', doc)"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        @click="triggerFileInput('certificatesFile')"
                      >
                        Upload File
                      </button>
                      <input
                        ref="certificatesFile"
                        type="file"
                        class="d-none"
                        @change="uploadDocument('certificates')"
                      >
                    </div>
                    <div
                      id="contracts"
                      class="tab-pane fade"
                      :class="{ show: activeTab === 'contracts', active: activeTab === 'contracts' }"
                      role="tabpanel"
                      aria-labelledby="contracts-tab"
                    >
                      <!-- Similar Contracts Content -->
                      <div v-if="documents.contracts.length === 0">
                        <p>No documents available.</p>
                      </div>
                      <div
                        v-for="(doc, index) in documents.contracts"
                        :key="index"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            target="_blank"
                            :href="mediaBase + doc"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ doc.split('/').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white delete-button"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteDocument('contracts', doc)"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        @click="triggerFileInput('contractsFile')"
                      >
                        Upload File
                      </button>
                      <input
                        ref="contractsFile"
                        type="file"
                        class="d-none"
                        @change="uploadDocument('contracts')"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="card">
                <div
                  v-if="editWorkingSectors"
                  class="card-body"
                >
                  <p class="lead">
                    {{ $t('companyProfile.faliyytSahsiniDyi') }}
                  </p>
                  <form @submit.prevent="saveWorkingSectors">
                    <div
                      class="card"
                      style="background: #dddddd"
                    >
                      <div class="card-body">
                        <SelectedSectorView
                          :sectors="selectedSectors"
                          :parent-id="0"
                        />

                        <div class="mt-3">
                          <a
                            v-b-modal.modal-sector-selection
                            class="btn btn-primary"
                          >
                            {{ $t('companyProfile.faliyytSahsiniSein') }}
                          </a>
                        </div>
                      </div>
                    </div>


                    <div class="mb-3">
                      <button
                        type="submit"
                        class="btn btn-primary mr-2"
                      >
                        {{ $t('companyProfile.dyiikliyiYaddaSaxla') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click.prevent="editWorkingSectors = false"
                      >
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  v-else
                  class="card-body"
                >
                  <SelectedSectorView
                    :sectors="sectors"
                    :parent-id="0"
                  />
                  <button
                    v-if="!hasAdmin || isAdmin"
                    class="btn btn-sm mt-2 btn-outline-primary d-flex align-items-center px-2"
                    @click.prevent="editWorkingSectors = true"
                  >
                    <feather
                      type="settings"
                      size="16"
                      class="mr-2"
                    />
                    {{ $t('companyProfile.faliyytSahlriniDyi') }}
                  </button>
                </div>
              </div>

              <div v-if="companyDetails.legalForm!=='PERSONAL'">
                <div class="mb-3">
                  <h3>{{ $t('dashboardCompany.irktIstifadilri') }}</h3>
                </div>

                <UserCompanyAdminDetails />

                <div
                  v-for="(u,i) in users"
                  :key="i"
                  class="card"
                  :class="{'bg-warning': isAdmin && u.status ==='new'}"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">
                        <img
                          class="rounded-circle img-fluid"
                          :src="getPhoto(u.user.photo,'mediumCropped')"
                          alt=""
                        >
                      </div>
                      <div class="col-7">
                        <h5>{{ u.user.name }} {{ u.user.surname }}</h5>
                        <h6>
                          <strong>{{ getProfileName(u.profileType) }}</strong>
                        </h6>
                        <p class="p-0 m-0">
                          {{ u.position }}
                        </p>
                        <span
                          v-if="u.status==='verified'"
                          class="badge bg-success"
                        >{{ $t('companyProfile.tsdiqlnmi') }}</span>
                        <span
                          v-else
                          class="badge bg-danger"
                        >{{ $t('companyProfile.tsdiqlnmmi') }}</span>
                        <span
                          v-if="adminUser && adminUser.id === u.user.id"
                          class="badge bg-primary ml-2"
                        >{{ $t('companyProfile.idari') }}</span>
                      </div>
                      <div
                        v-if=" isAdmin"
                        class="col-2"
                      >
                        <button
                          v-if="u.status!=='verified'"
                          type="button"
                          class="btn btn-sm btn-success px-3 mb-2"
                          @click="confirmUserProfile(u.id)"
                        >
                          <feather
                            type="check"
                            size="20"
                          />
                        </button>
                        <br>
                        <button
                          v-if="u.user.id !== user.id"
                          type="button"
                          class="btn btn-sm btn-danger  px-3"
                          @click="rejectUserProfile(u.id)"
                        >
                          <feather
                            type="x"
                            size="20"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-7 mt-3">
              <div class="card">
                <div class="card-body">
                  <h3>Product Inquiries</h3>
                  <ul class="list-group">
                    <li
                      v-for="(inquiry, index) in displayedInquiries"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <img
                          :src="mediaBase + inquiry.coverPhotoUrl"
                          class="img-thumbnail mr-2"
                          alt="Product Image"
                          style="width: 50px; height: 50px;"
                        >
                        <strong>{{ inquiry.productName }}</strong>
                        <p class="mb-1">
                          {{ inquiry.inquiryText }}
                        </p>
                        <small>{{ inquiry.inquiryTime }}</small>
                      </div>
                      <button
                        class="btn btn-primary btn-sm"
                        @click="startConversation(inquiry)"
                      >
                        Start Conversation
                      </button>
                    </li>
                  </ul>
                  <button
                    v-if="!showAllInquiries"
                    class="btn btn-primary mt-3"
                    @click="showAllInquiries = true"
                  >
                    Show All
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          v-else
          class="row"
      >
        <div class="col-sm-12 p-0">
          <div class="auth-innerright">
            <div class="authentication-box" />
            <div class="card mt-4 p-4">
              <div
                  class="alert alert-primary text-center my-4"
                  style="padding: 50px 20px;"
              >
                <feather
                    type="clock"
                    size="40"
                />
                <br>
                <span v-if="showDashboard===1">
                  {{
                    $t('dashboardVue.sizinBuIrktQoulmanzNIrktinizinAdminiTrfindnTsdiqln', {
                      adminName: company.adminName,
                      adminSurname: company.adminSurname
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      scrollable
      class="theme-modal"
      :busy="false"
    >
      <sector_selection_modal
        :parent-sector="null"
        :selected="selectedSectors"
        :max-selection="20"
        @done="($event)=>{selectedSectors = $event; $bvModal.hide('modal-sector-selection') }"
      />

      <template #modal-footer>
        <div class="text-warning">
          {{ $t('companyProfile.siz20FaliyytSahsiSeBilrsiniz') }}
        </div>
      </template>
    </b-modal>
  </div>
  <!-- Container-fluid Ends-->
</template>
<script>
import {mapState} from "vuex";
import {
  changeCompanyDetail,
  changeCompanySectors,
  companyUserAction,
  getCompanyDetails,
  getCompanyProfiles,
  getCompanyUsers,
  removeCompanyLogo,
  saveProfile,
  updateCompanyLogo,
  upload, userAccounts,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";

import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import UserCompanyAdminDetails from "@/pages/scc/account/UserCompanyAdminDetails.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import Multiselect from "vue-multiselect";
import {
  addDocument,
  addTaxDocument,
  deleteDocument,
  deleteTaxDocument,
  getCompanyDocuments,
  sendForVerification,
  updateConfirmMail,
  updateContactPhone
} from "@/repositories/ProductDataRepository";
import {getInquiriesForCompany} from "@/repositories/InquiryDataRepository";
import {startConversation} from "@/repositories/ProductConversationDataRepository";

export default {
  components: {
    SelectedSectorView,
    UserCompanyAdminDetails,
    Sector_selection_modal,
    Sector_path,
    CompanyRateStatistics,
    Multiselect,
    VuePhoneNumberInput
  },
  data() {
    return {
      activeTab: 'distributor', // Set default active tab
      documents: {
        distributor: [],
        certificates: [],
        contracts: []
      },
      mediaBase: mediaBase,
      companyDetails: null,
      showDashboard: 0,
      sectors: [],
      users: [],
      adminUser: null,
      profiles: {},
      uploadProgress: 0,
      activeProfile: '',
      allSectors: [],
      selectedSectors: [],
      editWorkingSectors: false,
      editProfileIsOpen: false,
      editingProfile: {},
      phoneNumberObject: null,
      companyActiveProfileData: null,
      inquiries: [],
      showAllInquiries: false,
      emailEditMode: false,
      phoneEditMode: false,
      phoneObject: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      hasAdmin: state => state.auth.hasAdmin,
      isAdmin: state => state.auth.isAdmin,
    }),
    buttonText() {
      switch (this.companyDetails.systemVerifiedCompany) {
        case 0:
          return this.$t('companyProfile.sendVerification');
        case 1:
          return this.$t('companyProfile.waitingForVerification');
        case 2:
          return this.$t('companyProfile.verified');
        default:
          return this.$t('companyProfile.resend');
      }
    },
    buttonClass() {
      switch (this.companyDetails.systemVerifiedCompany) {
        case 0:
          return 'btn-success';
        case 1:
          return 'btn-warning';
        case 2:
          return 'btn-secondary'; // Disabled style
        default:
          return 'btn-danger';
      }
    },
    companySupplyRating() {
      if (!this.companyDetails || this.companyDetails.supplyRateCount === null || this.companyDetails.supplyRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.supplyRateTotal / this.companyDetails.supplyRateCount).toFixed(1);
      }
    },
    companyProcurementRating() {
      if (!this.companyDetails || this.companyDetails.procurementRateCount === null || this.companyDetails.procurementRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.procurementRateTotal / this.companyDetails.procurementRateCount).toFixed(1);
      }
    },
    displayedInquiries() {
      return this.showAllInquiries ? this.inquiries : this.inquiries.slice(0, 10);
    }
  },
  watch: {
    editWorkingSectors(newVal) {
      if (newVal) {
        this.selectedSectors = this.sectors;
        this.phoneNumberObject = null;
      }
    },
    activeProfile(newVal) {
      this.editProfileIsOpen = false;
      this.companyActiveProfileData = this.profiles[newVal]
    },
    editProfileIsOpen(newVal) {
      if (newVal) {
        this.editingProfile = {...(this.profiles[this.activeProfile])};
      } else {
        this.editingProfile = {};
      }
    },
    profiles: {
      handler(newData) {
        if (newData[this.activeProfile]) {
          this.companyActiveProfileData = newData[this.activeProfile]
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getCompanyDetails();
    this.getCompanyUsers();
    this.getCompanyProfiles();
    this.getDocuments();
    this.getInquiries();
    this.userAccount();
    this.timer = setInterval(() => {
      this.userAccount();
    }, 5000)
    this.scheduler = setInterval(() => {
      if (this.companyDetails && (this.companyDetails.systemVerifiedCompany !== 1)) {
        // Stop the scheduler when systemVerifiedCompany is 2 or 3
        clearInterval(this.scheduler);
      } else {
        // Call getCompanyDetails every 3 seconds
        this.getCompanyDetails();
      }
    }, 3000);
  },
  methods: {
    userAccount() {

      userAccounts(this.token).then(data => {

        let ae = data.filter(profile => {
          return profile.company.id === this.company.id && profile.profileType === this.profile;
        });

        if (ae.length > 0 && this.company.adminName) {
          this.showDashboard = (ae[0].status === "verified") ? 0 : 1;
        }
        if (this.showDashboard === 0) {
          clearInterval(this.timer);
        }
        // this.showDashboard = (this.company.status === "VERIFIED" || this.company.status==="CONFIRMED") ? 0 : 2;
      });
    },
    enableEmailEditMode() {
      this.emailEditMode = true;
    },
    enablePhoneEditMode() {
      this.phoneEditMode = true;
    },
    triggerFileInput(refName) {
      this.$refs[refName].click();
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyDetails() {
      getCompanyDetails(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.companyDetails = data.company;
          this.sectors = data.sectors;
          this.selectedSectors = data.sectors;
        } else {
          this.$router.push({name: 'changeAccount'});
        }
      })
    },
    getCompanyUsers() {
      getCompanyUsers(this.token).then(data => {
        if (data.code === 200) {
          this.users = data.users;
          this.adminUser = data.adminUser;
        }
      })
    },
    getCompanyProfiles() {
      getCompanyProfiles(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          data.profiles.forEach(p => {
            this.profiles[p.profileType] = JSON.parse(p.profileData);
          })
          if (this.activeProfile === '' && data.profiles.length > 0) {
            this.activeProfile = data.profiles[0].profileType;
          } else {
            this.companyActiveProfileData = this.profiles[this.activeProfile]
          }
        }
      })
    },
    changeCompanyAddress() {
      this.$swal({
        title: this.$t("zhmtOlmsYnUnvn"),
        input: 'text',
        icon: 'question',
        inputValue: this.companyDetails.address,
      }).then((result) => {
        if (result.value) {
          changeCompanyDetail(this.token, 'address', result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("unvnUdlrDysdrl"),
                icon: 'success'
              }).then(() => {
                this.getCompanyDetails();
              })

            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }

      })

    },
    confirmUserProfile(id) {
      this.$swal({
        title: this.$t("prflTsdqEtmkIstdyn"),
        icon: 'question',
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'verify', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istfdCPrflTsqd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      })
    },
    rejectUserProfile(id) {
      this.$swal({
        title: this.$t("prflLgvTmkUchn"),
        icon: 'question',
        input: 'textarea'
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'reject', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istdfcPrflSlnd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        } else {
          alert(this.$t("sbbDxlEtmkVcbd"));
        }
      })
    },
    saveWorkingSectors() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      changeCompanySectors(this.token, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("flyytShlrDyshdrld"),
            icon: 'success'
          }).then(() => {
            this.editWorkingSectors = false;
            this.getCompanyDetails();
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    removeProfilePhoto() {
      if (confirm(this.$t("sklSlmkIstdyndn"))) {
        removeCompanyLogo(this.token).then(data => {
          if (data.code === 200) {
            this.getCompanyDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                updateCompanyLogo(this.token, response.data.path).then(data => {
                  if (data.code === 200) {
                    this.getCompanyDetails();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    saveProfile() {
      if (!this.phoneNumberObject || !this.phoneNumberObject.isValid) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("nmrnDzgnDxlDn"),
          icon: 'warning'
        })
      } else {

        let data = {
          phone: this.phoneNumberObject.e164,
          email: this.editingProfile.email,
          website: this.editingProfile.website,
          linkedin: this.editingProfile.linkedin
        };

        saveProfile(this.token, this.companyDetails.id, JSON.stringify(data), this.activeProfile).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("unvnUdlrDysdrl"),
              icon: 'success'
            }).then(() => {
              this.getCompanyProfiles();
              this.editProfileIsOpen = false;
            });
          } else {

            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },

    numberUpdated(p) {
      this.phoneNumberObject = p;
    },
    getDocuments() {
      getCompanyDocuments(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.documents.distributor = data.companyDocumentsDto.distributionDocuments || [];
          this.documents.certificates = data.companyDocumentsDto.certificatesAndLicenses || [];
          this.documents.contracts = data.companyDocumentsDto.contractsAndReferencesForSimilarWorks || [];
        }
      });
    },
    uploadDocument(type) {
      let fileInput;
      if (type === 'distributor') {
        fileInput = this.$refs.distributorFile;
      } else if (type === 'certificates') {
        fileInput = this.$refs.certificatesFile;
      } else if (type === 'contracts') {
        fileInput = this.$refs.contractsFile;
      }
      let currentFile = fileInput.files[0];
      if (currentFile) {
        upload(this.token, type, currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                const url = response.data.path;
                addDocument(this.token, type, url, this.company.id).then(data => {
                  if (data.code === 200) {
                    this.documents[type].push(url);
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error',
                    });
                  }
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch(e => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      }
    },
    uploadTaxDocument() {
      let fileInput = this.$refs.taxFile;
      let currentFile = fileInput.files[0];
      if (currentFile) {
        // Get the company ID to add it to the filename
        const newFileName = `taxDocument_${this.company.id}.${currentFile.name.split('.').pop()}`; // keeps the original extension
        const renamedFile = new File([currentFile], newFileName, {
          type: currentFile.type,
        });

        // Call the upload function with the renamed file
        upload(this.token, 'taxDocument', renamedFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }, true)
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                const url = response.data.path;
                addTaxDocument(this.token, url, this.company.id).then(data => {
                  if (data.code === 200) {
                    this.getCompanyDetails();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error',
                    });
                  }
                });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch(e => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      }
    },

    deleteDocument(type, doc) {
      deleteDocument(this.token, type, doc, this.company.id).then(data => {
        if (data.code === 200) {
          const index = this.documents[type].indexOf(doc);
          if (index > -1) {
            this.documents[type].splice(index, 1);
          }
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          });
        }
      });
    },
    deleteTaxDocument() {
      deleteTaxDocument(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.getCompanyDetails();
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          });
        }
      });
    },
    saveCompanyEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple regex for email validation

      if (!emailRegex.test(this.companyDetails.confirmEmail)) {
        // Show error message if email is invalid
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: "Email Yalnışdır", // Localized error message
          icon: 'error'
        });
        return; // Exit function to prevent further execution
      }
      updateConfirmMail(this.token, this.company.id, this.companyDetails.confirmEmail)
      this.emailEditMode = false;
      this.$swal({
        title: this.$t("generalModal.successTitle"),
        icon: 'success'
      });
    },
    saveCompanyPhone() {
      updateContactPhone(this.token, this.company.id,  this.companyDetails.contactPhone)
      this.phoneEditMode = false;
      this.$swal({
        title: this.$t("generalModal.successTitle"),
        icon: 'success'
      });
    },
    submitVerificationRequest() {
      // Handle verification request logic here
      const missingFields = [];
      if (this.emailEditMode || this.phoneEditMode) {
        missingFields.push(this.$t("companyProfile.pleaseSave"));
      }
      // Check each required field and push a message to `missingFields` if it's missing
      if (!this.companyDetails.confirmEmail) {
        missingFields.push(this.$t("companyProfile.emailRequired"));
      }
      if (!this.companyDetails.contactPhone) {
        missingFields.push(this.$t("companyProfile.phoneRequired"));
      }
      if (!this.companyDetails.taxId) {
        missingFields.push(this.$t("companyProfile.taxIdRequired"));
      }
      if (!this.companyDetails.address && this.companyDetails.legalForm !== 'PERSONAL') {
        missingFields.push(this.$t("companyProfile.addressRequired"));
      }
      if (this.companyDetails.countryCode !== 'AZ' && !this.companyDetails.taxIdDocument) {
        missingFields.push(this.$t("companyProfile.taxIdDocumentRequired"));
      }
      if (!this.companyDetails.logo) {
        missingFields.push(this.$t("companyProfile.logoRequired"));
      }

      // If there are missing fields, show them in a Swal alert
      if (missingFields.length > 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          html: `<ul>${missingFields.map(field => `<li>${field}</li>`).join('')}</ul>`,
          icon: 'warning'
        });
      } else {
        sendForVerification(this.token, this.company.id)

        this.$swal({
          title: this.$t("generalModal.successTitle"),
          icon: 'success'
        }).then(
            () => {
              window.location.reload();
            }
        );
      }
    },
    getInquiries() {
      getInquiriesForCompany(this.token).then(data => {

        if (data) {
          this.inquiries = data;
        }
      });

    },
    startConversation(inquiry) {
      // Implement your logic to start a conversation here

      try {
        // Call the startConversation function and pass the token and inquiry ID
        startConversation(this.token, inquiry.id).then(data => {
          if (data.code === 200) {
            // Get the conversation ID from the response
            const conversationId = data.id;

            // Redirect to the conversation page using the conversation ID
            this.$router.push(`/dashboard/conversation/${conversationId}`);
          } else {
            // Handle the error by showing an alert or message
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            });
          }
        });
        // Check if the response code is 200 (success)

      } catch (error) {
        // Handle any other errors
        this.$swal({
          title: 'Error',
          text: error.message,
          icon: 'error'
        });
      }
    }
  }
}
</script>
<style>
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  50% {
    opacity: 0;
  }
}
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
